module.exports = "/images/game_mask_0c1bc1.png";